import React from 'react';

/**
 * Logo de ArgendaBOT: campana de notificación con un rayo en el centro y un punto
 * de notificación arriba a la derecha, recoloreado a la paleta de la marca.
 *
 *   Círculo de fondo → negro   #0A0A0A
 *   Campana          → blanca  #FFFFFF
 *   Rayo             → amarillo #E4F527
 *   Punto de aviso   → amarillo #E4F527
 */
export default function Logo({ size = 40, title = 'ArgendaBOT' }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 64 64"
      role="img"
      aria-label={title}
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>{title}</title>
      {/* Círculo de fondo */}
      <circle cx="32" cy="32" r="32" fill="#0A0A0A" />

      {/* Campana */}
      <path
        d="M32 15c-6.6 0-12 5.4-12 12v6.2c0 1.3-.5 2.6-1.4 3.6l-2.3 2.5c-1.4 1.5-.3 4 1.8 4h27.8c2.1 0 3.2-2.5 1.8-4l-2.3-2.5c-.9-1-1.4-2.3-1.4-3.6V27c0-6.6-5.4-12-12-12z"
        fill="#FFFFFF"
      />
      {/* Badajo */}
      <path
        d="M27.5 47a4.6 4.6 0 0 0 9 0h-9z"
        fill="#FFFFFF"
      />

      {/* Rayo en el centro */}
      <path
        d="M33.6 22.5l-7.2 9.3h4.9l-1.7 7.7 7.4-9.7h-5l1.6-7.3z"
        fill="#E4F527"
      />

      {/* Punto de notificación (arriba a la derecha) */}
      <circle cx="49" cy="16" r="8" fill="#E4F527" stroke="#FFFFFF" strokeWidth="2.5" />
    </svg>
  );
}
